"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var google_libphonenumber_1 = require("google-libphonenumber");
var TextInput_1 = __importDefault(require("../TextInput"));
var Dropdown_1 = __importDefault(require("../Dropdown"));
var Label_1 = __importDefault(require("../Label"));
var Validation_1 = __importDefault(require("../Validation"));
var Hint_1 = __importDefault(require("../Hint"));
var countryCodes_1 = require("./countryCodes");
var const_1 = require("./const");
var utils_1 = require("./utils");
var styles_1 = require("./styles");
var phoneUtil = google_libphonenumber_1.PhoneNumberUtil.getInstance();
var countryCodeOptions = countryCodes_1.countryCodes.map(function (cc) { return ({
    value: cc.code,
    label: "".concat(cc.name, " ").concat(cc.dial_code),
    prefix: cc.flag,
    countryCode: cc.code,
}); });
var PhoneInput = function (_a) {
    var _b, _c;
    var onChange = _a.onChange, validation = _a.validation, _d = _a.required, required = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.placeholder, placeholder = _f === void 0 ? '' : _f, testId = _a.testId, iconColorType = _a.iconColorType, iconName = _a.iconName, hint = _a.hint, warning = _a.warning, value = _a.value, label = _a.label, country = _a.country, _g = _a.dropdownDirection, dropdownDirection = _g === void 0 ? 'down' : _g, setParentCountryCode = _a.setParentCountryCode, setParentCountryDial = _a.setParentCountryDial;
    var _h = (0, react_1.useState)((0, utils_1.getCountryCode)(value, country) || const_1.DEFAULT_COUNTRY_CODE), countryCode = _h[0], setCountryCode = _h[1];
    var countryDial = (_c = (_b = countryCodes_1.countryCodes.find(function (cc) { return cc.code === countryCode; })) === null || _b === void 0 ? void 0 : _b.dial_code) !== null && _c !== void 0 ? _c : '';
    var _j = (0, react_1.useState)(false), isDropdownFocused = _j[0], setIsDropdownFocused = _j[1];
    var formatPhoneNumber = (0, react_1.useCallback)(function (inputNumber) {
        try {
            var number = phoneUtil.parseAndKeepRawInput(inputNumber, countryCode);
            return phoneUtil.format(number, google_libphonenumber_1.PhoneNumberFormat.INTERNATIONAL);
        }
        catch (error) {
            return inputNumber;
        }
    }, [countryCode]);
    (0, react_1.useEffect)(function () {
        if (value) {
            var formattedValue = formatPhoneNumber(value);
            if (formattedValue !== value) {
                onChange(formattedValue, true);
            }
            setParentCountryCode === null || setParentCountryCode === void 0 ? void 0 : setParentCountryCode(countryCode);
            setParentCountryDial === null || setParentCountryDial === void 0 ? void 0 : setParentCountryDial(countryDial);
        }
    }, [value, countryCode, formatPhoneNumber, onChange]);
    var handleChange = (0, react_1.useCallback)(function (event) {
        var newValue = event.currentTarget.value;
        var onlyNumbers = newValue.replace(/\D/g, '');
        var sanitizedValue = newValue.replace(/\s/g, '');
        if (onlyNumbers.length <= const_1.MAXIMUM_PHONE_LENGTH &&
            (/^[0-9- ]+$/.test(newValue) || newValue === '') &&
            !newValue.includes('--')) {
            var formattedValue = newValue ? formatPhoneNumber(countryDial + sanitizedValue) : '';
            onChange(formattedValue, true);
        }
    }, [countryDial, formatPhoneNumber, onChange]);
    var localValue = value.replace(countryDial, '').replace('+', '');
    var handleChangeCountry = (0, react_1.useCallback)(function (newCountryCode) {
        var newCountryDial = (0, utils_1.getDialCodeForCountry)(newCountryCode);
        setCountryCode(newCountryCode);
        if (value) {
            onChange(value.replace(countryDial, newCountryDial), true);
        }
        setParentCountryCode === null || setParentCountryCode === void 0 ? void 0 : setParentCountryCode(newCountryCode);
        setParentCountryDial === null || setParentCountryDial === void 0 ? void 0 : setParentCountryDial(newCountryDial);
    }, [value, countryDial, onChange, setParentCountryCode, setParentCountryDial]);
    var toggleDropdownFocus = (0, react_1.useCallback)(function (isFocused) {
        setIsDropdownFocused(isFocused);
    }, []);
    // Create a descriptive aria-label
    var getAriaLabel = function () {
        var ariaLabel = label || 'Phone number';
        // if (required) ariaLabel += ' (required)';
        if (placeholder && !label)
            ariaLabel = placeholder;
        return ariaLabel;
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ "data-testid": testId }, { children: [label && ((0, jsx_runtime_1.jsx)(Label_1.default, __assign({ required: required, htmlFor: "phone-input" }, { children: label }))), (0, jsx_runtime_1.jsxs)(styles_1.InputRow, { children: [(0, jsx_runtime_1.jsxs)(styles_1.DropdownContainer, __assign({ style: { zIndex: isDropdownFocused && !validation ? 1 : undefined } }, { children: [(0, jsx_runtime_1.jsx)(Dropdown_1.default, { size: "lg", disabled: disabled, value: countryCode, options: countryCodeOptions, onChange: handleChangeCountry, optionsWidth: 260, floatable: true, displayValue: countryDial, onFocus: function () { return toggleDropdownFocus(true); }, onBlur: function () { return toggleDropdownFocus(false); }, direction: dropdownDirection, noMarginBottom: true, "aria-label": "Country ".concat(getAriaLabel()), "aria-required": required }), !!validation && (0, jsx_runtime_1.jsx)(styles_1.ValidationBorder, {})] })), (0, jsx_runtime_1.jsxs)(styles_1.TextInputContainer, { children: [(0, jsx_runtime_1.jsx)(TextInput_1.default, { value: localValue, onChange: handleChange, placeholder: placeholder, disabled: disabled, style: { height: 50 }, iconName: iconName, iconColorType: iconColorType, id: "phone-input", "aria-label": "Mobile ".concat(getAriaLabel()), "aria-required": required, "aria-invalid": !!validation }), !!validation && (0, jsx_runtime_1.jsx)(styles_1.ValidationBorder, { style: { borderLeft: 'none' } })] })] }), validation && (0, jsx_runtime_1.jsx)(Validation_1.default, { children: validation }), hint && !validation && !warning && (0, jsx_runtime_1.jsx)(Hint_1.default, { children: hint }), !validation && !hint && warning && (0, jsx_runtime_1.jsx)(Validation_1.default, __assign({ type: "warning" }, { children: warning }))] })));
};
exports.default = PhoneInput;
